import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  header: {
    alignItems: "center",
    marginBottom: 10,
    position: "relative",
  },
  logo: {
    width: "100px",
    height: "auto",
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  reportTitle: {
    fontSize: 16,
    color: "#000",
    marginBottom: 3,
  },
  reportPeriod: {
    fontSize: 14,
    color: "#000",
    marginBottom: 3,
  },
  entryCount: {
    fontSize: 14,
    color: "#000",
  },
  contentBox: {
    border: "0.5px solid #171717",
    marginTop: 10,
  },
  clientBar: {
    backgroundColor: "#1D2939",
    color: "#fff",
    padding: "8px 12px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  clientInfo: {
    fontSize: 11,
    color: "#FAFAFA",
  },
  dateInfo: {
    fontSize: 14,
    color: "#FFF",
  },
  cardContainer: {
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: "8px 0px 3px 5px",
  },
  card: {
    width: "32%",
    marginRight: "1%",
    marginBottom: 6,
    overflow: "hidden",
    border: "1px solid #D9D9D9",
    borderRadius: 8,
  },
  cardHeader: {
    backgroundColor: "#F4F3FF",
    padding: 8,
    borderBottom: "1px solid #D9D9D9",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  cardTitle: {
    fontSize: 14,
    color: "#000",
  },
  cardBody: {
    padding: "13px 6px 8px 6px",
  },
  checkItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  checkbox: {
    width: 14,
    height: 14,
    border: "1px solid #D0D5DD",
    marginRight: 8,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  checked: {
    backgroundColor: "#FAFAFA",
    borderColor: "#404040",
  },
  checkmark: {
    width: 8,
  },
  itemText: {
    fontSize: 12,
    borderRadius: 16,
    backgroundColor: "#F2F4F7",
    padding: "3px 8px 3px 8px",
    color: "#525252",
  },
  checkedText: {
    backgroundColor: "#FFF6ED",
    color: "#C4320A",
  },
  checkedItemDis: {
    padding: "8px 10px 7px 10px",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    marginBottom: 10,
    marginLeft: 22,
    color: "#000",
    fontSize: 11,
    minHeight: 28,
    display: "flex",
    alignItems: "center",
  },
  commentsHeader: {
    backgroundColor: "#A3A3A3",
    borderBottom: "0.5px solid #000",
    color: "#FAFAFA",
    padding: "6px 10px",
    fontSize: 14,
  },
  comment: {
    padding: "10px",
    borderBottom: "0.5px solid #000",
    backgroundColor: "#E2E8F0",
  },
  commentAuthor: {
    fontWeight: "bold",
    marginBottom: 4,
    color: "#101828",
    fontSize: 10,
  },
  commentText: {
    fontSize: 11,
    color: "#000",
  },
  lastSection: {
    padding: "8 12",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  shiftInfo: {
    flexDirection: "row",
    alignItems: "center",
  },

  staffInfo: {
    flexDirection: "row",
    alignItems: "center",
  },

  staffAndShiftLabel: {
    fontSize: 11,
    fontWeight: "800",
    color: "#101828",
    paddingRight: 8,
  },

  staffName: {
    fontSize: 11,
    color: "#101828",
  },

  signature: {
    backgroundColor: "#E5E5E5",
    filter: "drop-shadow(0 1px 2px rgba(16, 24, 40, 0.05))",
    width: "100px",
    height: "40px",
    borderRadius: 8,
    display: "flex",
    marginLeft: "15px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  sigText: {
    fontSize: 18,
    color: "#000",
    fontFamily: "Island Moments",
  },
  coverPage: {
    position: "relative",
    flex: 1,
  },

  coverWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  coverBg: {
    width: "100%",
    height: "100%",
  },

  coverContent: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
  },

  coverFacility: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
  },

  coverFacilityLabel: {
    fontSize: 16,
    color: "#DEDFE1",
    marginRight: "10px",
  },
  coverFacilityName: {
    fontSize: 16,
    color: "#000000",
  },
});
